import React, { useEffect } from "react";
import "./Features.css";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCount } from "../../../redux/aboutus";

const Features = ({ count }) => {
  //   const dispatch = useDispatch();
  // const count = useSelector((state) => state?.aboutus?.count);
  // // console.log(whychoose,"whychoose")

  // useEffect(() => {
  //   dispatch(GetAllCount());
  // }, [dispatch]);

  return (
    <section className="Features">
      <div className="container">
        <div className="features_holder">
          <div className="row justify-content-center">
            {count?.length > 0
              ? count?.map((item, index) => (
                  <div className="col-lg-3 col-md-3 col-sm-4 col-6">
                    <div className="features_div">
                      <h5>
                        {/* 5000+ */}
                        {item?.countnumber}
                      </h5>
                      <p>
                        {/* Students Assessed Through Structured Career Tests */}
                        {item?.name}
                      </p>
                    </div>
                  </div>

                  // <div className="col-lg-3 col-md-3 col-sm-4 col-6">
                  //   <div className="features_div">
                  //     <h5>2000+</h5>
                  //     <p>Successful One-to-One Counselling Sessions</p>
                  //   </div>
                  // </div>

                  // <div className="col-lg-3 col-md-3 col-sm-4 col-6">
                  //   <div className="features_div">
                  //     <h5>300+</h5>
                  //     <p>Career Paths & Course Options Mapped</p>
                  //   </div>
                  // </div>

                  // <div className="col-lg-3 col-md-3 col-sm-4 col-6">
                  //   <div className="features_div">
                  //     <h5>95%</h5>
                  //     <p>Student & Parent Satisfaction Rate</p>
                  //   </div>
                  // </div>
                ))
              : "not Found"}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
